export default "__VITE_ASSET__UJsnYPlf__"